/*
 *
 * ChatbotWrapper
 *
 * @version 1.0.0
 * @author Marco Alessandroni
 * @since 12-May-2025
 */

import React from 'react'
import { useLocation } from 'react-router-dom'
import { CHATBOT_ENABLED_ROUTES } from './chatbotRouteConfig'
import Chatbot from 'Components/Chatbot'
import { Capacitor } from '@capacitor/core'

const ChatbotWrapper = () => {
  const location = useLocation()

  const isVisible = !Capacitor.isNativePlatform() && CHATBOT_ENABLED_ROUTES.some((path) =>
    location.pathname === path
  )

  return isVisible ? <Chatbot /> : null
}

export default ChatbotWrapper
